// Login configuration
export default {
  oidc: {
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: process.env.REACT_APP_APP_URL + '/implicit/callback',
    scope: "openid acoer profile"
  }
};
